module.exports = "@value darkGrey300 from \"colors.module.css\";\n\n.coloredBg {\n  background-color: darkGrey300;\n  padding: 10px;\n}\n"